var React = require('react');

function BlobMobileInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M413 62.2476C358.829 66.3427 297.889 73.9864 257.689 51.7985C123.568 -22.2289 158.478 92.0301 -1.50034 53.5952L-1.50031 0.499988L413 0.499998L413 62.2476Z","fill":"#FFE4E4"}));
}

BlobMobileInline.defaultProps = {"width":"413","height":"67","viewBox":"0 0 413 67","fill":"none","preserveAspectRatio":"none"};

module.exports = BlobMobileInline;

BlobMobileInline.default = BlobMobileInline;
